import { Addendum } from "@/core/types";
import { Button2 } from "@/ui2/atoms/Button";

import { getAddendumActionDate } from "../helpers/getAddendumActionDate";

type AddendumActionProps = {
  addendum: Addendum;
  isAuthor: boolean;
  isEditMode: boolean;
  isRejected: boolean;
  onEditPress: () => void;
};

export function AddendumActions({
  addendum,
  isAuthor,
  isEditMode,
  isRejected,
  onEditPress,
}: AddendumActionProps) {
  const statusDate = getAddendumActionDate(addendum);
  const displayEditButton = isAuthor && isRejected && !isEditMode;

  if (statusDate) return <time dateTime={statusDate.dateTime}>{statusDate.display}</time>;
  if (displayEditButton)
    return (
      <Button2 onPress={onEditPress} variant="link">
        Edit
      </Button2>
    );

  return null;
}
